import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'row',
    margin: '24px',
  },
  oneColumn: {
    width: '100%',
  },
  leftColumn: {
    overflow: 'scroll',
    width: '60%',
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '40%',
  },
  border: {
    borderLeft: '1px solid rgba(151,151,151,0.4)',
    height: '100%',
    marginLeft: 16,
    paddingLeft: 16,
    marginTop: 10,
  },
  bigLock: {
    color: theme.palette.greyScale[1],
    height: '50px',
    width: '30px',
  },
  connectPara: {
    color: theme.palette.greyScale[2],
    paddingTop: 5,
  },
  progress: {
    display: 'block',
    margin: '72px auto 0px',
  },
  loadingRoot: {
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
  },
  loadingLine: {
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'row',
    color: '#666666',
    paddingTop: 20,
    alignContent: 'center',
  },
  check: {
    color: '#1e88e5',
    paddingRight: 10,
    paddingBottom: 5,
    transform: 'scale(1.5)',
  },
  noUnder: {
    textDecoration: 'none',
  },
  accountsTopBar: {
    width: '100%',
    minHeight: 32,
    padding: '0 12px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.greyScale[5],
  },
  accountUpdateText: {
    padding: '8px 0',
    color: theme.palette.greyScale[0],
    verticalAlign: 'middle',
  },
}));
